import * as React from "react";
import styled from "../../../styled/index";
import { CS } from "../../../styles/index";
import { RestaurantIcon, RestaurantIconList } from "../restaurant.icon/index";
const Wrapper = styled("div") `
  background: ${({ background }) => background};
  color: ${({ text }) => text};
  display: inline-block;
  border-radius: 30px;
  padding: 3px;
  font-size: 13px;
`;
const Content = styled("div") `
  min-height: 20px;
  ${CS.flex.line_center};
  flex-wrap: nowrap;
`;
const Icon = styled("div") `
  background: ${({ background }) => background};
  color: ${({ text }) => text};
  border-radius: 30px;
  padding: 3px ${({ type }) => type === "text" ? 6 : 1}px;
  font-weight: 600;
  white-space: pre-wrap;

  img{ 
    width: 15px;
    height: 15px;
  }
`;
const Text = styled("div") `
  margin: 0 5px;
  font-weight: 600;
  white-space: pre-wrap;
`;
export const DishTag = (props) => {
    const isIcon = props.type === "icon";
    const isSvgIcon = Object.keys(RestaurantIconList).includes(props.icon);
    return (React.createElement(Wrapper, Object.assign({}, props.color.wrapper),
        React.createElement(Content, null,
            props.type !== "none" && isSvgIcon && (React.createElement(Icon, Object.assign({ type: props.type }, props.color.icon),
                isIcon && React.createElement(RestaurantIcon, { icon: props.icon }),
                !isIcon && React.createElement("span", null, props.icon))),
            props.type !== "none" && !isSvgIcon && (React.createElement(Icon, Object.assign({ type: props.type }, props.color.icon),
                React.createElement("img", { src: `/images/dish_tags/${props.icon + '.png'}` }))),
            props.text && React.createElement(Text, null, props.text))));
};
//# sourceMappingURL=index.js.map